import { Link, type LinkProps } from "@tanstack/react-router";
import type { ReactNode } from "react";

type TextLinkProps = LinkProps & { children: ReactNode };

export const textLinkClass =
  "font-medium text-accent underline-offset-4 hover:underline pointer-coarse:inline-flex pointer-coarse:min-h-11 pointer-coarse:items-center";

export function TextLink(props: TextLinkProps) {
  return <Link className={textLinkClass} {...props} />;
}
